import type { FC } from 'react';
import { StatusBadge } from '@pages/User/components';

export const StatusCell: FC<{ status: string }> = ({ status }) => (
  <div>
    <StatusBadge status={status} className="whitespace-nowrap" />
  </div>
);
